import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import DateUtils from 'src/app/utils/date';

@Component({
  selector: 'app-year-range-filter',
  templateUrl: './year-range-filter.component.html',
  styleUrls: ['./year-range-filter.component.css']
})
export class YearRangeFilterComponent implements OnInit {
  @Input() selectedYr = new Date().getFullYear();
  @Input() selectedPeriod = 'monthly';
  @Output() dateChange = new EventEmitter();

  dateUtil = new DateUtils;
  years: any[];
  constructor() {
    this.years = this.dateUtil.getYears();    
   }

  ngOnInit() {
  }
  dateFilterChanged() {
    this.dateChange.emit({selectedYr: this.selectedYr, selectedPeriod: this.selectedPeriod})
  }

}
